import { defineDictionary } from "gemi/client";

export const authModalV2Dict = defineDictionary({
  "sign-in": {
    "en-US": "Sign In",
    "tr-TR": "Giriş Yap",
    "de-DE": "Anmelden",
    "es-ES": "Iniciar Sesión",
    "fr-FR": "Se Connecter",
    "it-IT": "Accedi",
    "ru-RU": "Войти",
  },
  "sign-up": {
    "en-US": "Sign Up",
    "tr-TR": "Kayıt Ol",
    "de-DE": "Registrieren",
    "es-ES": "Registrarse",
    "fr-FR": "S'inscrire",
    "it-IT": "Registrati",
    "ru-RU": "Зарегистрироваться",
  },
  "pin-sent-to-email": {
    "en-US": "We sent a PIN code to {{email}}",
    "tr-TR": "{{email}} adresine PIN kodu gönderdik",
    "de-DE": "Wir haben einen PIN-Code an {{email}} gesendet",
    "es-ES": "Enviamos un código PIN a {{email}}",
    "fr-FR": "Nous avons envoyé un code PIN à {{email}}",
    "it-IT": "Abbiamo inviato un codice PIN a {{email}}",
    "ru-RU": "Мы отправили PIN-код на {{email}}",
  },
  "pin-code": {
    "en-US": "PIN Code",
    "tr-TR": "PIN Kodu",
    "de-DE": "PIN-Code",
    "es-ES": "Código PIN",
    "fr-FR": "Code PIN",
    "it-IT": "Codice PIN",
    "ru-RU": "PIN-код",
  },
  "send-pin-code": {
    "en-US": "Send PIN Code",
    "tr-TR": "PIN Kodu Gönder",
    "de-DE": "PIN-Code senden",
    "es-ES": "Enviar código PIN",
    "fr-FR": "Envoyer le code PIN",
    "it-IT": "Invia codice PIN",
    "ru-RU": "Отправить PIN-код",
  },
  "verify-pin": {
    "en-US": "Verify PIN",
    "tr-TR": "PIN'i Doğrula",
    "de-DE": "PIN verifizieren",
    "es-ES": "Verificar PIN",
    "fr-FR": "Vérifier le PIN",
    "it-IT": "Verifica PIN",
    "ru-RU": "Проверить PIN",
  },
  "back-to-email": {
    "en-US": "Back to email",
    "tr-TR": "E-postaya geri dön",
    "de-DE": "Zurück zur E-Mail",
    "es-ES": "Volver al correo",
    "fr-FR": "Retour à l'e-mail",
    "it-IT": "Torna all'email",
    "ru-RU": "Назад к электронной почте",
  },
  "dont-have-account": {
    "en-US": "Don't have an account?",
    "tr-TR": "Hesabınız yok mu?",
    "de-DE": "Haben Sie kein Konto?",
    "es-ES": "¿No tienes una cuenta?",
    "fr-FR": "Vous n'avez pas de compte ?",
    "it-IT": "Non hai un account?",
    "ru-RU": "Нет аккаунта?",
  },
  "already-have-account": {
    "en-US": "Already have an account?",
    "tr-TR": "Zaten hesabınız var mı?",
    "de-DE": "Haben Sie bereits ein Konto?",
    "es-ES": "¿Ya tienes una cuenta?",
    "fr-FR": "Vous avez déjà un compte ?",
    "it-IT": "Hai già un account?",
    "ru-RU": "Уже есть аккаунт?",
  },
  "enter-your-email": {
    "en-US": "Enter your email",
    "tr-TR": "E-posta adresinizi girin",
    "de-DE": "Geben Sie Ihre E-Mail ein",
    "es-ES": "Ingrese su correo electrónico",
    "fr-FR": "Entrez votre e-mail",
    "it-IT": "Inserisci la tua email",
    "ru-RU": "Введите свой адрес электронной почты",
  },
  "enter-your-name": {
    "en-US": "Enter your name",
    "tr-TR": "Adınızı girin",
    "de-DE": "Geben Sie Ihren Namen ein",
    "es-ES": "Ingrese su nombre",
    "fr-FR": "Entrez votre nom",
    "it-IT": "Inserisci il tuo nome",
    "ru-RU": "Введите ваше имя",
  },
  "create-account": {
    "en-US": "Create Account",
    "tr-TR": "Hesap Oluştur",
    "de-DE": "Konto erstellen",
    "es-ES": "Crear Cuenta",
    "fr-FR": "Créer un Compte",
    "it-IT": "Crea Account",
    "ru-RU": "Создать Аккаунт",
  },
  "get-started": {
    "en-US": "Get started with your account",
    "tr-TR": "Hesabınızla başlayın",
    "de-DE": "Beginnen Sie mit Ihrem Konto",
    "es-ES": "Comience con su cuenta",
    "fr-FR": "Commencez avec votre compte",
    "it-IT": "Inizia con il tuo account",
    "ru-RU": "Начните с вашего аккаунта",
  },
  "access-your-account": {
    "en-US": "Access your account",
    "tr-TR": "Hesabınıza erişin",
    "de-DE": "Greifen Sie auf Ihr Konto zu",
    "es-ES": "Accede a tu cuenta",
    "fr-FR": "Accédez à votre compte",
    "it-IT": "Accedi al tuo account",
    "ru-RU": "Доступ к вашему аккаунту",
  },
  "continue-with-google": {
    "en-US": "Continue with Google",
    "tr-TR": "Google ile devam et",
    "de-DE": "Mit Google fortfahren",
    "es-ES": "Continuar con Google",
    "fr-FR": "Continuer avec Google",
    "it-IT": "Continua con Google",
    "ru-RU": "Продолжить с Google",
  },
  "sign-in-with-email": {
    "en-US": "Sign In with Email",
    "tr-TR": "E-posta ile Giriş Yap",
    "de-DE": "Mit E-Mail anmelden",
    "es-ES": "Iniciar sesión con correo",
    "fr-FR": "Se connecter avec e-mail",
    "it-IT": "Accedi con email",
    "ru-RU": "Войти через электронную почту",
  },
  "sign-up-with-google": {
    "en-US": "Sign Up with Google",
    "tr-TR": "Google ile Kayıt Ol",
    "de-DE": "Mit Google registrieren",
    "es-ES": "Registrarse con Google",
    "fr-FR": "S'inscrire avec Google",
    "it-IT": "Registrati con Google",
    "ru-RU": "Зарегистрироваться через Google",
  },
  "sign-up-with-email": {
    "en-US": "Sign Up with Email",
    "tr-TR": "E-posta ile Kayıt Ol",
    "de-DE": "Mit E-Mail registrieren",
    "es-ES": "Registrarse con correo",
    "fr-FR": "S'inscrire avec e-mail",
    "it-IT": "Registrati con email",
    "ru-RU": "Зарегистрироваться через почту",
  },
  back: {
    "en-US": "Back",
    "tr-TR": "Geri",
    "de-DE": "Zurück",
    "es-ES": "Atrás",
    "fr-FR": "Retour",
    "it-IT": "Indietro",
    "ru-RU": "Назад",
  },
});
